<template>
  <div>
    <cs-dialog v-model="isShownDialog">
      <dialog-list-layout>
        <div
          v-for="({ label, diff }, intervalKey) in presets"
          :key="`period_${intervalKey}_${diff}`"
          :class="{
            [$style.container]: true,
            [$style.active]: isActivePreset(intervalKey),
          }"
          @click="handleClick(intervalKey)"
        >
          <div :class="$style.content">
            <div :class="$style.title">
              {{ $t(label) }}
            </div>
          </div>
        </div>
      </dialog-list-layout>
    </cs-dialog>
  </div>
</template>

<script>
import {
  getMomentConstructor,
  getDateAsISOString,
  subtractDaysFromDate
} from 'lib/utils/date';

import { EVENT_BUS } from '@/eventBus';

import DialogListLayout from 'modules/Dialogs/ListLayout';

const moment = getMomentConstructor();

const TODAY = 'today';
const YESTERDAY = 'yesterday';
const WEEK = 'week';
const MONTH = 'month';
const QUARTER = 'quarter';

const TIME_INTERVAL_PRESETS = {
  [TODAY]: {
    diff: 0,
    label: 'common.today',
  },
  [YESTERDAY]: {
    diff: 1,
    label: 'common.yesterday',
  },
  [WEEK]: {
    diff: 6,
    label: 'seven.days',
  },
  [MONTH]: {
    diff: 29,
    label: 'thirty.days',
  },
  [QUARTER]: {
    diff: 89,
    label: 'three.monthes',
  },
};

export default {
  name: 'SelectingPeriodPreset',
  components: {
    DialogListLayout,
  },
  created() {
    EVENT_BUS.$on('SELECTING_PERIOD_PRESET', preset => {
      this.currentPreset = preset;
      this.isShownDialog = true;
    });
  },
  data() {
    return {
      presets: TIME_INTERVAL_PRESETS,
      isShownDialog: false,
      currentPreset: {
        dateFrom: null,
        dateTo: null,
      },
    };
  },
  methods: {
    preparedIntervalByKey(intervalKey) {
      const currentDate = moment();

      let preparedDate = null;
      let preparedInterval = {
        dateFrom: null, // 2021-06-24Т00:00:00+03:00
        dateTo: null, // 2021-06-24Т00:00:00+03:00
      };

      switch (intervalKey) {
        case TODAY:
          preparedInterval.dateFrom = currentDate.startOf('day');
          preparedInterval.dateTo = currentDate.endOf('day');
          break;
        case YESTERDAY:
          preparedDate = subtractDaysFromDate(currentDate, this.presets[intervalKey].diff);
          preparedInterval.dateFrom = preparedDate.startOf('day');
          preparedInterval.dateTo = preparedDate.endOf('day');
          break;
        case WEEK:
        case MONTH:
        case QUARTER:
          preparedDate = subtractDaysFromDate(currentDate, this.presets[intervalKey].diff);
          preparedInterval.dateFrom = preparedDate.startOf('day');
          preparedInterval.dateTo = currentDate.endOf('day');
          break;
      }

      return preparedInterval;
    },
    isActivePreset(intervalKey) {
      if (!this.currentPreset.dateFrom && !this.currentPreset.dateTo) {
        return;
      }

      const preparedInterval = this.preparedIntervalByKey(intervalKey);
      const isValidDateFrom = getDateAsISOString(this.currentPreset.dateFrom) === getDateAsISOString(preparedInterval.dateFrom);
      const isValidDateTo = getDateAsISOString(this.currentPreset.dateTo) === getDateAsISOString(preparedInterval.dateTo);
      const isActivePreset = isValidDateFrom && isValidDateTo;

      return isActivePreset;
    },
    handleClick(intervalKey) {
      const changedInterval = this.preparedIntervalByKey(intervalKey);

      EVENT_BUS.$emit('SELECTED_PERIOD_PRESET', changedInterval);
      this.isShownDialog = false;
    },
  },
};
</script>

<style lang="sass" module>
  .container
    border-radius: 5px
    background-color: #1E1E2D
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15)
    cursor: pointer

    &.active
      background-color: #2F3049

  .content
    display: flex
    align-items: center
    justify-content: space-between
    padding: 20px

  .title
    font-weight: 500
    font-size: 14px
    line-height: 17px
</style>
